import { headingSizeProp, headingTagProp, wysiwygProp } from 'utils/proptypes/modules/textProps';

import ButtonsList from 'components/buttons/ButtonsList';
import FlexibleWrapper from 'components/wrappers/FlexibleWrapper';
import Heading from 'components/text/Heading';
import Paragraph from 'components/text/Paragraph';
import PropTypes from 'prop-types';
import React from 'react';
import { TextLinkWysisyg } from 'components/text/TextLink';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import { buttonsProp } from 'utils/proptypes/modules/buttonsProps';
import styled from 'libs/styled';

const ContentBox = styled('div')`
    position: relative;
    text-align: inherit;
    z-index: 1;
`;

/**
 *  contentBlock used to display heading, text and buttons on a background.
 *
 *param {array} buttons - An array of button objects.
 * @param {object} buttonListStyle - Optional styling for ButtonsList.
 * @param {array} buttons - Buttons as array.
 * @param {string} heading - Heading as a string.
 * @param {string} headingSize - The size of heading passed as props to Heading.
 * @param {string} headingTag - The html-tag used by heading; h1, h2, h3 etc.
 * @param {string} tag - Small tag displayed above heading.
 * @param {array} text - Text as a wysiwyg-array.
 * @param {*} rest - Props to pass to FlexibleWrapper.
 */

const Flexible = ({
    buttonListStyle = {},
    buttons = [],
    heading,
    headingSize = 'md',
    headingTag = 'h2',
    tag,
    text,
    textSize,
    ...rest
}) => {
    const validTags = ['url', 'i', 'b', 'u', 'ul', 'ol', 'li', 'span'];

    return (
        <FlexibleWrapper {...rest}>
            <ContentBox>
                {heading && (
                    <Heading as={headingTag} m={['32px 0', null, null, '56px 0']} size={headingSize}>
                        {heading}
                    </Heading>
                )}
                {tag && <Paragraph mb="24px">{tag}</Paragraph>}
                {text && (
                    <Wysiwyg
                        data={text}
                        textComponent={props => (
                            <Paragraph mb={buttons.length > 0 ? '24px' : null} size={textSize} {...props} />
                        )}
                        validTags={validTags}
                        tagComponents={{ url: TextLinkWysisyg }}
                    />
                )}
                {buttons.length > 0 && <ButtonsList {...buttonListStyle} buttons={buttons} />}
            </ContentBox>
        </FlexibleWrapper>
    );
};

Flexible.propTypes = {
    buttonListStyle: PropTypes.object,
    buttons: buttonsProp,
    heading: PropTypes.string,
    headingSize: headingSizeProp,
    headingTag: headingTagProp,
    tag: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    text: PropTypes.oneOfType([PropTypes.bool, wysiwygProp]),
    textSize: PropTypes.string,
};

export default Flexible;
